'use strict';
import ngMaterial from 'angular-material';
import ngFileUpload from 'ng-file-upload';
import CredentialListController from './credential-list.controller';
import CredentialEditForm from '../forms/account/credential-edit';
import CredentialAddForm from '../forms/account/credential-add';
import CredentialListService from './credential-list.service';
export default angular.module('directives.credentialList', [CredentialEditForm, CredentialAddForm, ngMaterial, 'dialog', ngFileUpload])
    .service('CredentialListService', CredentialListService)
    .component('credentialList', {
    template: require('./credential-list.html'),
    controller: CredentialListController
})
    .name;
//# sourceMappingURL=index.js.map